var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 245,
    viewBox: "0 0 1035 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1413.49 -103.475C1320.37 -88.2763 1310.28 -149.948 1217.16 -134.75C1124.03 -119.551 1134.11 -57.8822 1040.97 -42.6863C947.841 -27.4904 941.134 -76.1959 848 -61C754.866 -45.8041 761.583 2.90362 668.449 18.0995C575.325 33.2977 566.124 -11.1982 473 4.00001C379.877 19.1982 388.865 63.5803 295.731 78.7762C202.597 93.9721 193.134 50.3041 100 65.5C6.86611 80.6959 16.3388 124.366 -76.7953 139.562",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1427.23 14.6921C1334.1 29.8903 1324.02 -31.7813 1230.89 -16.5831C1137.77 -1.38484 1157.13 44.8038 1064 59.9996C970.866 75.1955 951.501 29.0069 858.366 44.2028C798 54.0522 769.124 106.801 676 122C582.877 137.198 558 98.9996 485.648 104.879C419.864 110.226 423 161.665 302 184C208.866 199.196 168 156.711 113.122 165.665C19.9882 180.861 30.0739 242.533 -63.0602 257.729",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.95 132.892C1347.83 148.09 1337.74 86.4184 1244.62 101.617C1151.5 116.815 1176.13 146.302 1083 161.498C990.5 183.498 934.5 139.998 883.5 144.498C800.5 168.998 769.134 212.302 676 227.498C582.876 242.696 522 195.998 490 209.498C458 222.998 366 281.498 293.5 287.498C214.334 294.05 152.5 267.998 124 267.998C62.1861 267.998 43.8012 360.733 -49.3329 375.928",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg75);
export default __webpack_public_path__ + "static/media/bg_75.8c1fd7e4b5e32f80a3b4a07b88b0a9d5.svg";
export { ForwardRef as ReactComponent };